// // // // keycloak.js
import Keycloak from "keycloak-js";

const keycloakConfig = {
  realm: process.env.REACT_APP_REALM,
  url: process.env.REACT_APP_KEYCLOAK_URL,
  clientId: process.env.REACT_APP_CLIENT_ID,
  "ssl-required": "external",
  "public-client": true,
  "confidential-port": 0,
  public_key: process.env.REACT_APP_SECRET_KEY_,
};

const keycloakInstEguru = new Keycloak(keycloakConfig);

export default keycloakInstEguru;